import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Nav,
  Button,
  Modal,
  FormCheck,
} from "react-bootstrap"
import CandidateData from "./CandidateData"
import "./Admin.css" // Import the CSS file
import {
  downloadCandidates,
  fetchAdmins,
  toggleAuthenticated,
} from "../app/functions"
import LogoutButton from "../components/LogoutButton"
import Feedback from "../components/Feedback"
import ResultModal from "../components/ResultModal"

const Admin = () => {
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [selectedCandidateData, setSelectedCandidateData] = useState(null)
  const [candidates, setCandidates] = useState()
  const [showAdminModal, setShowAdminModal] = useState(false)
  const [showResultModal, setShowResultModal] = useState(false)
  const [adminProfiles, setAdminProfiles] = useState([])

  const admin_user = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    initProgram()
  }, [])

  const initProgram = async () => {
    let download = await downloadCandidates()
    setCandidates(download)

    let admins = await fetchAdmins()
    setAdminProfiles(admins)
  }

  const handleCandidateClick = (candidate) => {
    setSelectedCandidate(candidate.uid)
    setSelectedCandidateData(candidate)
  }
  const handleClose = () => setShowAdminModal(false)
  const closeResultModal = () => setShowResultModal(false)

  const changeAuthenticatedAdmin = async (id, authenticated) => {
    let newProfiles = await toggleAuthenticated(id, authenticated)
    setAdminProfiles(newProfiles)
  }

  return (
    <div className="admin-container">
      <Container fluid>
        <Row>
          {/* Left side: Menu with Candidate List */}
          <Col
            md={3}
            className="bg-rotary p-3 rounded per90 mb-2"
            style={{
              border: "2px solid #f7a81b",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              overflowY: "auto",
            }}
          >
            <h4 className="text-white">Kandydaci stypendialni</h4>
            <Nav className="flex-column">
              {candidates?.map((candidate, index) => (
                <Nav.Link
                  key={index}
                  className={` ${
                    selectedCandidate === candidate.uid
                      ? "text-black"
                      : "text-white"
                  }`}
                  onClick={() => handleCandidateClick(candidate)}
                >
                  {index + 1}. {candidate.name} {candidate.surname}
                  <hr />
                </Nav.Link>
              ))}
            </Nav>
            <div style={{ position: "absolute", bottom: 15, left: 20 }}>
              <LogoutButton />
              {admin_user.superadmin === true && (
                <Button
                  onClick={() => setShowAdminModal(true)}
                  className=" mx-2"
                >
                  Administratorzy
                </Button>
              )}

              {/* Display only if superadmin */}
              {/* {
                (admin_user.superadmin === true) &&  */}
              <Button onClick={() => setShowResultModal(true)}>
                Rezultaty
              </Button>
              {/* } */}
            </div>
          </Col>

          {/* Right side: Candidate Data */}
          <Col md={9}>
            {selectedCandidateData ? (
              <div style={{ dispaly: "flex", flexDirection: "column" }}>
                <CandidateData
                  uid={selectedCandidate}
                  candidateData={selectedCandidateData}
                />
                <Feedback
                  uid={selectedCandidate}
                  candidateData={selectedCandidateData}
                />
              </div>
            ) : (
              <h1 className="text-white">Wybierz Kandydata z menu!</h1>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={showAdminModal} centered onHide={handleClose}>
        <Modal.Title className="justify-center flex flex-col items-center p-4 pb-0">
          <div className="mb-2">Lista administratorów</div>
          <div style={{ fontSize: 16, fontWeight: "normal" }}>
            Zaznacz użytkownika, aby nadać mu uprawnienia administratorskie.
          </div>
        </Modal.Title>
        <Modal.Body className="justify-center flex flex-col items-center p-4">
          <div className="flex flex-col gap-4">
            <div
              className="flex  items-center p-2 border-b w-full"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <strong>Email</strong>
              <strong>Uprawnienia</strong>
            </div>
            {adminProfiles?.map((user) => (
              <div
                key={user.id}
                className="flex  items-center p-2 border-b w-full"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>{user.email}</div>
                <FormCheck
                  checked={user.authenticated === true}
                  // disabled
                  type="switch"
                  onChange={() =>
                    changeAuthenticatedAdmin(user.id, user.authenticated)
                  }
                />
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
      <ResultModal
        showResultModal={showResultModal}
        handleClose={closeResultModal}
        handleCandidateClick={handleCandidateClick}
      />
    </div>
  )
}

export default Admin
